import React,{Component} from 'react';
import './Tabela.css';
import Pagination from './Pagination';

class TabelaHotarari extends Component{
  
  constructor(props){
    super(props);
    this.state={
      hotarariElo:this.props.hotarariElo,
      cautareNume:[],
      cautareTitlu:[],
      hotarariElofiltrate:props.hotarariElo,
      aniElo:props.aniElo,
      hotararecurent:null,
      currentPage:null,
      totalPages:null,
      selectedAn:props.selectedAn
    }
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    
    // if (this.props.hotarariElo!== prevProps.hotarariElo) {
    //   this.setState({hotararecurent:null,
    //     currentPage:null,
    //     totalPages:null});
    // }
    //   this.setState({hotarariElo:this.props.hotarariElo,cautareNume:this.props.cautareNume,cautareTitlu:this.props.cautareTitlu},
    //     this.setState({hotarariElofiltrate:this.state.hotarariElo}));
    //     console.log("----",this.state.hotarariElo);
    // }
    // this.setState({hotarariElo:this.props.hotarariElo,cautareNume:this.props.cautareNume,cautareTitlu:this.props.cautareTitlu});
    
  }

  componentWillReceiveProps(nextprops){
    // if(nextprops.selectedAn!==this.props.selectedAn){
    //   this.setState({
    //     currentPage:null,
    //     totalPages:null});
    // }
    // for (const index in nextprops) {
    //   if (nextprops[index] !== this.props[index]) {
    //      console.log("--",index, this.props[index], '-->', nextprops[index]);
    //     this.setState({hotararecurent:null,
    //       currentPage:null,
    //       totalPages:null});
    //   }
    // }

    this.setState({selectedAn:nextprops.selectedAn,hotarariElo:nextprops.hotarariElo,hotarariElofiltrate:nextprops.hotarariElo,cautareNume:nextprops.cautareNume,cautareTitlu:nextprops.cautareTitlu});
  }
    
  pregatesteRanduriTabel=(lista)=>{
    let filteredHotarari=
      lista.map(hotarare=>
         (<tr key={hotarare.url}>
          <td>{hotarare.nume}</td>
          <td>{hotarare.anul}</td>
          <td>{hotarare.descriere}</td>
          <td><a href={hotarare.url} target="_blank" rel="noopener noreferrer">vizualizare</a></td>
      </tr>))
      //  this.setState({hotarariElofiltrate:filteredHotarari});
      return filteredHotarari;
  }


  handleChange=(tipCautare,event)=>{
    // console.log(tipCautare);
    let ListaCurenta=[];
    let ListaFiltrata=[];
    ListaCurenta=this.state.hotarariElo;
    ListaFiltrata=ListaCurenta;
    if(event&&event.target.value.trim()!==""){
      ListaFiltrata=ListaCurenta.filter(item=>{
            let lc; 
            if(tipCautare==="nume"){
              document.getElementById('cautDescriere').value= "" ;
              lc=item.nume.toUpperCase();
            }else{
              document.getElementById('cautNume').value= "" ;
              lc=item.descriere.toUpperCase();
            }
            const filter = event.target.value.toUpperCase();
            return lc.includes(filter);
          }
        )
    }else{
      if(tipCautare==="nume"){
        document.getElementById('cautNume').value= "" ;
      }else{
        document.getElementById('cautDescriere').value= "" ;
      }
    }
    if((event)&&(ListaFiltrata.length<1 && event.target.value.trim()===""))
    {
      ListaFiltrata=ListaCurenta;
    }
    this.setState({hotarariElofiltrate:ListaFiltrata});
  }

  onPageChanged = data => {
    let { currentPage, totalPages, pageLimit } = data;
    let offset = (currentPage - 1) * pageLimit;
    let hotararecurent = this.pregatesteRanduriTabel(this.state.hotarariElofiltrate).slice(offset, offset + pageLimit);

    this.setState({ currentPage, hotararecurent, totalPages });
  }

  
  render(){
      let marimeLista=this.state.hotarariElofiltrate.length;
      return (

      <div className="Hotarari">
          <div className="d-flex flex-row py justify-content-start">
            <input type="text" id="cautNume" className="input" onChange={(e)=>this.handleChange("nume",e)} placeholder={this.state.cautareNume} />
          </div>
          
          <input type="text" id="cautDescriere" className="input" onChange={(e)=>this.handleChange("descriere",e)} placeholder={this.state.cautareTitlu} />
        <div className="d-flex flex-row py justify-content-start">
        { (marimeLista!==0)?      
          this.state.currentPage && (
                <span className="current-page d-inline-block h-100 pl-4 text-secondary">
                  Pagina <span className="font-weight-bold">{ this.state.currentPage }</span> / <span className="font-weight-bold">{ this.state.totalPages }</span>
                </span>
              ):"Reluați Căutarea" }
        </div>
        <div className="d-flex flex-row  py align-items-center">
              <Pagination totalRecords={this.state.hotarariElofiltrate.length} pageLimit={18} pageNeighbours={1} onPageChanged={this.onPageChanged} selectedAn={this.state.selectedAn}/>
        </div>
        <table id="tabb">
            <thead>
            <tr>
                <th>Nume</th>
                <th>Anul</th>
                <th>Titlu</th>
                <th>Vizualizare</th>
            </tr>
            </thead>
            <tfoot>
            <tr>
                <td colSpan="4">
                    <p>Primăria Municipiului Brăila</p>
                </td>
            </tr>
            </tfoot>
            <tbody>
              {this.state.hotararecurent} 
            </tbody>
        </table>
        
      </div>
    );
  }

}


export default TabelaHotarari;


